module.exports = __webpack_public_path__ + "img/img5.4e22fdd9.png";